function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M108.282 93.843l-16.54-11.702-.04-.03c-2.067-1.467-2.067-4.755 0-6.224l.04-.028 16.54-11.703c15.445-10.927 24.462-27.632 24.462-45.315H25.258c0 17.683 9.017 34.387 24.461 45.315l16.54 11.703.04.028c2.067 1.468 2.067 4.757 0 6.225l-.04.029-16.54 11.702c-15.444 10.927-24.461 27.632-24.461 45.315h107.486c0-17.683-9.017-34.387-24.462-45.315z",
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.312 75.888l.036-.029 14.731-11.702c13.756-10.928 21.788-27.632 21.788-45.315H31.133c0 17.683 8.031 34.387 21.787 45.315l14.731 11.702.036.029c.92.734 6.117 4.373 11.313 4.373 5.195 0 10.392-3.64 11.312-4.373z",
  fill: "url(#paint1_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M67.687 83.373l-.035.029L52.92 95.104c-13.755 10.928-21.787 27.632-21.787 45.315h95.733c0-17.683-8.031-34.387-21.787-45.315L90.348 83.402l-.036-.029C89.392 82.64 84.195 79 78.999 79c-5.195 0-10.391 3.639-11.312 4.373z",
  fill: "url(#paint2_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.702 75.888a4.1 4.1 0 00.04-.029l16.54-11.702c15.444-10.928 24.461-27.632 24.461-45.315H25.258c0 1.758.093 3.506.268 5.24l1.107 1.56 106.109 113.42c-.032-17.647-9.043-34.311-24.46-45.22L91.742 82.14l-.04-.028c-2.067-1.468-2.067-4.756 0-6.224z",
  fill: "url(#paint3_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M119.817 138.978c-.026-9.792-4.824-18.865-12.567-24.097L90.393 103.49C84.34 99.4 80.67 92.278 80.67 84.624c0-5.355 4.417-8.765 4.417-8.765l16.15-11.701a52.867 52.867 0 004.798-5.116c.947-1.154.385-2.974-1.015-3.318a108.746 108.746 0 00-52.04 0c-1.399.344-1.962 2.165-1.015 3.318a52.783 52.783 0 004.798 5.116l16.15 11.7s4.418 3.412 4.418 8.766c0 7.654-3.67 14.775-9.723 18.866L50.75 114.881c-7.743 5.233-12.541 14.305-12.567 24.097v.178h81.633v-.178z",
  fill: "url(#paint4_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M119.817 138.978c-.026-9.792-4.824-18.865-12.567-24.097L90.393 103.49C84.34 99.4 80.67 92.278 80.67 84.624c0-2.058.653-3.827 1.456-5.228A13.415 13.415 0 0079 79a13.43 13.43 0 00-3.126.396c.804 1.4 1.457 3.17 1.457 5.228 0 7.654-3.67 14.775-9.723 18.866L50.75 114.881c-7.743 5.233-12.541 14.305-12.567 24.097v.178h81.633v-.178z",
  fill: "url(#paint5_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M119.817 138.978c-.026-9.792-4.824-18.865-12.567-24.097L90.393 103.49C84.34 99.4 80.67 92.278 80.67 84.624c0-2.058.653-3.827 1.456-5.228A13.415 13.415 0 0079 79a13.43 13.43 0 00-3.126.396c.804 1.4 1.457 3.17 1.457 5.228 0 7.654-3.67 14.775-9.723 18.866L50.75 114.881c-7.743 5.233-12.541 14.305-12.567 24.097v.178h81.633v-.178z",
  fill: "url(#paint6_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.604 20.965h-6.346v115.419h6.346V20.964z",
  fill: "url(#paint7_linear)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.258 25.516l.345.126 6 6V20.966h-6.345v4.55z",
  fill: "url(#paint8_linear)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M132.742 20.965h-6.346v115.419h6.346V20.964z",
  fill: "url(#paint9_linear)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M126.396 25.516l.346.126 6 6V20.966h-6.346v4.55z",
  fill: "url(#paint10_linear)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M134.976 158H23.024a5.028 5.028 0 01-5.028-5.028v-15.586a5.028 5.028 0 015.028-5.027h111.951a5.028 5.028 0 015.028 5.027v15.586a5.027 5.027 0 01-5.027 5.028z",
  fill: "url(#paint11_linear)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M134.976 25.642H23.024a5.028 5.028 0 01-5.028-5.028V5.028A5.028 5.028 0 0123.024 0h111.951a5.028 5.028 0 015.028 5.028v15.586a5.027 5.027 0 01-5.027 5.028z",
  fill: "url(#paint12_linear)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M179.987 132c0-22.092-17.906-40-39.994-40C117.906 92 100 109.908 100 132s17.906 40 39.993 40c22.088 0 39.994-17.908 39.994-40z",
  fill: "#F36986"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M164.664 100.516a39.838 39.838 0 018.515 24.676c0 22.091-17.906 40-39.994 40a39.816 39.816 0 01-24.671-8.517c7.321 9.331 18.7 15.325 31.479 15.325 22.088 0 39.993-17.908 39.993-40 0-12.781-5.993-24.161-15.322-31.484z",
  fill: "#FC476E"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M142.533 138.719h-5.079a1.821 1.821 0 01-1.821-1.822v-23c0-1.006.815-1.822 1.821-1.822h5.079c1.006 0 1.822.816 1.822 1.822v23a1.822 1.822 0 01-1.822 1.822z",
  fill: "#FFD2E3"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M142.534 112.075h-3.292c1.006 0 1.821.816 1.821 1.822v23a1.821 1.821 0 01-1.821 1.822h3.292a1.821 1.821 0 001.821-1.822v-23a1.821 1.821 0 00-1.821-1.822z",
  fill: "#FFBBD7"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M139.994 153.219a4.361 4.361 0 01-4.361-4.361v-.001a4.361 4.361 0 118.722 0v.001a4.362 4.362 0 01-4.361 4.361z",
  fill: "#FFD2E3"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M139.994 144.495c-.351 0-.692.043-1.019.121a4.363 4.363 0 010 8.482 4.361 4.361 0 101.019-8.603z",
  fill: "#FFBBD7"
});

var _ref21 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 79.002,
  y1: 31.076,
  x2: 79.002,
  y2: 73.75,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EFEE"
})), React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 43.701,
  y1: 109.076,
  x2: 161.471,
  y2: 109.076,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FFC200",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 0.63,
  stopColor: "#EB7E00",
  stopOpacity: 0.63
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E05A00"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 79.002,
  y1: 79.07,
  x2: 79.002,
  y2: 151.005,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EFEE"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 100.362,
  y1: 46.565,
  x2: -38.152,
  y2: -91.95,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C2CECE",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 0.179,
  stopColor: "#AFBCBC",
  stopOpacity: 0.179
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#5B6A6A"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 79.002,
  y1: 44.427,
  x2: 79.002,
  y2: 107.629,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FFCF95"
}), React.createElement("stop", {
  offset: 0.427,
  stopColor: "#FFC954"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC200"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 79.002,
  y1: 95.426,
  x2: 79.002,
  y2: 140.859,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FFCF95"
}), React.createElement("stop", {
  offset: 0.427,
  stopColor: "#FFC954"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC200"
})), React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 79.003,
  y1: 0.097,
  x2: 79.003,
  y2: 151.195,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EFEE"
})), React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 59.546,
  y1: 131.009,
  x2: 64.372,
  y2: 139.127,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C69C6D"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#A67C52"
})), React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 48.018,
  y1: 42.823,
  x2: 22.982,
  y2: 17.786,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C69C6D",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#754C24"
})), React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 160.679,
  y1: 131.03,
  x2: 165.501,
  y2: 139.147,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C69C6D"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#A67C52"
})), React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 149.159,
  y1: 42.824,
  x2: 124.125,
  y2: 17.787,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C69C6D",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#754C24"
})), React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 79.002,
  y1: 150.215,
  x2: 79.002,
  y2: 158.332,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C69C6D"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#A67C52"
})), React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 79.002,
  y1: 17.852,
  x2: 79.002,
  y2: 25.971,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C69C6D"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#A67C52"
})));

var SvgCancellationIcon = function SvgCancellationIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 180,
    height: 172,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCancellationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancellation-icon.d2e28ea6.svg";
export { ForwardRef as ReactComponent };